import { render, staticRenderFns } from "./StockValueReport.vue?vue&type=template&id=0b556e19&scoped=true"
import script from "./StockValueReport.vue?vue&type=script&lang=ts"
export * from "./StockValueReport.vue?vue&type=script&lang=ts"
import style0 from "./StockValueReport.vue?vue&type=style&index=0&id=0b556e19&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b556e19",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sandeep/Work/EIOSYS/Cona-OSUM/Cona-Electrical-Admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b556e19')) {
      api.createRecord('0b556e19', component.options)
    } else {
      api.reload('0b556e19', component.options)
    }
    module.hot.accept("./StockValueReport.vue?vue&type=template&id=0b556e19&scoped=true", function () {
      api.rerender('0b556e19', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/reports/StockValueReport.vue"
export default component.exports